(function() {
  var script = document.currentScript;
  var lookupUrl = script && script.dataset ? script.dataset.mjsSkuLookupUrl : '';
  var params = new URLSearchParams(window.location.search);
  var rawQuery = params.get('q') || '';
  var skuQuery = normalizeSku(rawQuery);

  if (!lookupUrl || !skuQuery || params.get('mjs_sku_redirected') === '1') {
    return;
  }

  if (!isLikelySku(skuQuery)) {
    return;
  }

  fetch(lookupUrl, { cache: 'no-store' })
    .then(function(response) {
      if (!response.ok) throw new Error('SKU lookup unavailable');
      return response.json();
    })
    .then(function(data) {
      var match = data && data.skus ? data.skus[skuQuery] : null;
      if (!match && skuQuery.indexOf('001-') === 0) {
        match = data.skus[skuQuery.replace(/^001-/, '')];
      }
      if (!match && skuQuery.indexOf('001-') !== 0) {
        match = data.skus['001-' + skuQuery];
      }
      var matchUrl = typeof match === 'string' ? match : match.url;
      if (!matchUrl) return;

      var destination = new URL(matchUrl, window.location.origin);
      destination.searchParams.set('mjs_sku_redirected', '1');
      window.location.replace(destination.toString());
    })
    .catch(function() {
      // Keep normal Shopify search available if the lookup file is unavailable.
    });

  function normalizeSku(value) {
    return String(value || '')
      .trim()
      .replace(/[\u2013\u2014]/g, '-')
      .replace(/\s+/g, '')
      .toUpperCase();
  }

  function isLikelySku(value) {
    return /^(?:\d{3}-)?\d{3}-\d{3,6}$/.test(value);
  }
})();
